import { Component, OnInit } from '@angular/core';
import {
  EmailNotificationConfiguration,
  EmailNotificationType,
} from "src/app/domain/notifications-configuration";
import { MessageService } from "src/app/message/message.service";
import { Severity } from "src/app/message/Severity";
import { ConfigurationService } from "../../configuration.service";

@Component({
  selector: 'app-notification-email',
  templateUrl: './notification-email.component.html',
  styleUrls: ['./notification-email.component.scss'],
})
export class NotificationEmailComponent implements OnInit {
  constructor(
    private configurationService: ConfigurationService,
    private messageService: MessageService
  ) {}

  emailNotifications: EmailNotificationConfiguration[];

  ADMIN_CONFIG_TYPE = 'notificationEmail';
  types = [
    { label: 'Due Soon', value: EmailNotificationType.duesoon },
    { label: 'Past Due', value: EmailNotificationType.pastdue },
  ];

  ngOnInit(): void {
    this.emailNotifications = [] as EmailNotificationConfiguration[];
    this.configurationService.get(this.ADMIN_CONFIG_TYPE).subscribe(results => {
      this.emailNotifications = results;
    }, err => {
      console.log(err);
    });
  }

  add() {
    this.emailNotifications.push({
      emails: [],
      inspectors: [],
      type: EmailNotificationType.duesoon,
    } as EmailNotificationConfiguration);
  }

  save() {
    this.configurationService.update(this.ADMIN_CONFIG_TYPE, this.emailNotifications).subscribe(
      () => {
        this.messageService.add({ severity: Severity.SUCCESS, value: 'The configuration has been updated.' });
        window.scrollTo(0, 0);
      },
      error => {
        this.messageService.add({ severity: Severity.ERROR, value: 'The configuration failed to update due to: ' + error.message });
        window.scrollTo(0, 0);
    }
    );
  }

  remove(index) {
    if (index > -1) {
      this.emailNotifications.splice(index, 1);
      this.save();
    }
  }
}
